import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components/lib/Image";
import chevron from "@common/images/glossaryDropdown.svg";
import { GlossaryDispatch } from "../../Glossary";

import style from "./style.module.scss";

export function ChevronIcon(props) {
  const { toggleIndexCollapse } = React.useContext(GlossaryDispatch);

  const className = `${style.chevronIcon} ${props.className}`;

  const onChevronClick = () => {
    toggleIndexCollapse();
  };

  return <Image src={chevron} className={className} onClick={onChevronClick} />;
}

ChevronIcon.propTypes = {
  /**
   * Style from outside the component
   */
  className: PropTypes.string,
};

ChevronIcon.defaultProps = {
  className: "",
};
